import { toDate, getYear, isSameDay, isWeekend } from "date-fns";

const toInteger = (dirtyNumber: number) => {
  if (dirtyNumber === null) {
    return NaN;
  }

  const number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
};

const holidays = [
  // Den obnovy samostatného českého státu
  [1, 1],
  // Nový rok
  [1, 1],
  // Velký pátek
  [29, 3],
  // Velikonoční pondělí
  [1, 4],
  // Svátek práce
  [1, 5],
  // Den vítězství
  [8, 5],
  // Den slovanských věrozvěstů Cyrila a Metoděje
  [5, 7],
  // Den upálení mistra Jana Husa
  [6, 7],
  // Den české státnosti
  [28, 9],
  // Den vzniku samostatného československého státu
  [28, 10],
  // Den boje za svobodu a demokracii
  [17, 11],
  // Štědrý den
  [24, 12],
  // 1. svátek vánoční
  [25, 12],
  // 2. svátek vánoční
  [26, 12],
];

const isHoliday = (date: Date) => {
  const year = getYear(date);

  return holidays.some(([day, month]) =>
    isSameDay(date, new Date(year, month - 1, day))
  );
};

/**
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Adapted from https://github.com/date-fns/date-fns/blob/master/src/addBusinessDays/index.js
 * and https://github.com/jonstuebe/date-fns-holiday-us/blob/master/src/index.ts
 *
 * Add the specified number of business days (mon - fri) to the given date,
 * ignoring weekends and holidays.
 *
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be added
 * @returns {Date} the new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * var result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */
export default function addBusinessDays(date: Date | number, amount: number) {
  const cleanDate = toDate(date);
  const cleanAmount = toInteger(amount);

  if (isNaN(cleanAmount)) return new Date(NaN);

  const hours = cleanDate.getHours();
  let numWeekDays = 0;
  while (numWeekDays < cleanAmount) {
    cleanDate.setDate(cleanDate.getDate() + 1);
    cleanDate.setHours(hours);
    if (isBusinessDay(cleanDate)) numWeekDays++;
  }

  return cleanDate;
}

export const isBusinessDay = (date: Date): boolean =>
  !isWeekend(date) && !isHoliday(date);
